var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-btn',{attrs:{"color":"error","icon":"mdi-close-circle"},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }